<template>
  <div class="wrapper">
    <div class="result">
      <!-- 订单号码 -->
        <div class="order-id">{{$t('orderNumber')}} ：{{order_id}}</div>
        <div class="order-time">{{$t('paymenttime')}}：{{orderTime}}</div>

      <div class="list-head order-box">
        <div class="order-list">{{$t('project')}}</div>
      </div>
      <div class="order-box list-box">
        <div class="order-list">
          <div v-for="(item,index) in items" :key="index" class="product-item">
              <el-checkbox v-model="item.checked" @change="getReturnData"></el-checkbox>
            <img :src="item.image_url" :alt="item.name" class="product-img">
            <div class="shop-info">
              <div class="title">{{item.name}}</div>
              <div class="addon" v-if="item.addon"> {{item.addon}}  </div>
              <div class="desc">
                <div class="item">{{$t('Purchased')}}： {{item.nums}} </div>
                <div class="item"> {{$t('Shipped')}}：{{item.sendnums}} </div>
                <div class="item">
                  {{$t('refundable')}}：
                  <el-input-number v-model="item.returnNums" 
                  :min="0" :max="item.nums" size="mini" 
                  @change="getReturnData"></el-input-number>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="a-box">
      <span class="a-label">{{$t('toShip')}}：</span>
      <div class="a-main">
        <!-- 未发货 -->
        <el-radio v-model="type" label="1" @change="radioChange">{{$t('notShipped')}}</el-radio>
        <!-- 已发货 -->
        <el-radio v-model="type" label="2" :disabled="isDisabled">{{$t('shippedTab')}}</el-radio>
      </div>
    </div>
    <div class="a-box money">
      <span class="a-label top10">{{$t('refundAmount')}}：</span>
      <div class="a-main">
        <!-- :readonly="type==1" -->
        <input type="number" disabled v-model="refund" class="a-price-input">
        <!-- <span class="desc"> {{$t('modifyRefund', {text1: moneyData, text2:listData.cost_freight })}}</span> -->
      </div>
    </div>
    <div class="a-box">
      <span class="a-label top10">{{$t('refund', {text: $t('explain')})}}：</span>
      <div class="a-main">
        <textarea
          name
          id
          cols="50"
          rows="5"
          maxlength="200"
          :placeholder="$t('refund', {text: $t('explain')})"
          class="textarea"
          v-model="reason"
        ></textarea>
      </div>
    </div>
    <div class="a-box">
      <span class="a-label top10">{{$t('uploadPicture')}}：</span>
      <div class="a-main">
        <el-upload
          :action="upLoadUrl"
          list-type="picture-card"
          :limit="5"
          :http-request="e=>handleUpload(e)"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible">
          <img width="100%" :src="dialogImageUrl" alt>
        </el-dialog>
      </div>
    </div>
    <div class="submit" @click="handleSubmit">{{$t('submit')}}</div>
  </div>
</template>

<script>
import { timeToDate, formatMoney} from "@/utils";
import {apiBaseUrl} from "@/config/env.js";
export default {
  name: "RefundApply",
  components: {},
  props: {},
  data() {
    return {
      order_id: "",
      orderTime: "",
      type: "1",
      dialogImageUrl: "",
      dialogVisible: false,
      isDisabled: false, //是否禁用退货
      items: [], //商品列表
      refund: 0, //退款价格
      refund_show: 0, //可输入最大退款金额
      reason: "", //退款原因
      images: [],
      upLoadUrl: apiBaseUrl + "api.html",
      dialogVisible: false,
      dialogImageUrl: "",
      listData:{},
      checkedItems: [],
      // item_ids: []
    };
  },
  watch: {},
  computed: {
    moneyData () {
      if(this.listData.order_amount) {
        return formatMoney((this.listData.order_amount - this.listData.refunded), 2, '');
      }
    },
    item_ids () {
      let selectItems = this.items.filter(item => {
        return item.checked;
      });
      let item_ids = [];
      if (this.type == 1) {
        selectItems.forEach(item => {
          item_ids.push({
            id: item.id,
            // nums: item.nums,
            nums: item.returnNums

          });
        });
      } else {
        selectItems.forEach(item => {
          if (item.sendnums > item.reship_nums) {
            let nums = item.sendnums - item.reship_nums;
            console.log(nums)
            item_ids.push({
              id: item.id,
              // nums: item.nums,
              nums: item.returnNums
            });
          }
        });
      }
      return item_ids;
    }
  },
  methods: {
    getReturnData(){

      console.log(this.items)
      this.checkedItems = this.items
			let nums = 0;
			// this.item_ids = [];
      let total_refund = 0;//最退款金额
      
      for(var i = 0; i<this.items.length;i++)
      {
        if(this.items[i].checked){
          
            if(this.items[i].nums >= this.items[i].reship_nums) {
                nums = this.items[i].nums - this.items[i].reship_nums;
                if (nums>=this.items[i].returnNums) {
                  nums = this.items[i].returnNums
                  // this.item_ids = this.item_ids.concat({ id: k, nums: nums });
                  if(nums == (this.items[i].nums - this.items[i].reship_nums)){
                    total_refund += (this.items[i].ave_amount * 100 - this.items[i].reship_nums*this.items[i].ave_price * 100) / 100;
                  }else{
                    total_refund += (this.items[i].ave_price*nums*100) / 100;
                  }
                } else {
                  this.$message({
                    message: this.$t('numError'),
                    type: 'warning'
                  })
                  // this.$common.errorToShow(this.$t("numError"))
                  return ;
                }
              }
        }
      }
			this.refund = total_refund.toFixed(2);
		},
    //上传图片
    handleUpload(e) {
      var formdata = new FormData();
      formdata.append("upfile", e.file, e.file.name);
      this.$api.uploadImage(this.upLoadUrl, formdata).then(res => {
        if (res.status) {
          this.images = this.images.concat(res.data.image_id);
        } else {
          this.$msg(res.msg, "error");
        }
      });
    },
    handleSubmit() {
      if (this.refund > this.refund_show) {
        return this.$msg(this.$t('maxRefund'), "warning");
      }
      if (this.item_ids.length == 0) {
        return this.$msg(this.$t('selectGoods'), "warning");
      }
      let data = {
        order_id: this.order_id,
        type: this.type,
        items: this.item_ids,
        images: this.images,
        refund: this.refund,
        reason: this.reason
      };
      this.$api.addAfterSales(data).then(res => {
        if (res.status) {
          this.$msg(this.$t('submitSuccessfully')); // 提交成功
          this.$router.go(-1);
        } else {
          this.$msg(res.msg, "error");
        }
      });
    },
    radioChange(val) {
      console.log(val)
      this.refund = this.refund_show;
    },
    changeSelected(item, index) {
      if (item.checked) {
        this.items[index].checked = false;
      } else {
        this.items[index].checked = true;
      }
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    //获取订单商品信息
    getOrderInfo() {
      let data = {
        order_id: this.order_id
      };
      this.$api.orderDetail(data).then(res => {
        if (res.status) {
          //如果不是未支付的，已取消的，已完成的状态，就都可以售后
          if (
            res.data.text_status != 1 &&
            res.data.text_status != 6 &&
            res.data.text_status != 7
          ) {
            //判断是已付款未发货，如果是，就禁用退货
            if (res.data.text_status == 2) {
              this.isDisabled = true;
            }

            //设置已选中的商品
            for (var i = 0; i < res.data.items.length; i++) {
              res.data.items[i].id = res.data.items[i].id.toString();
              if (res.data.items[i].nums - res.data.items[i].reship_nums > 0) {
                res.data.items[i].checked = true
              }
            }
            this.items = res.data.items.map(item => {
              return {
                ...item,
                returnNums: item.nums -  item.reship_nums
              }
            })
            // this.items = res.data.items;
            // this.refund = res.data.payed - res.data.refunded;
            this.refund = (res.data.payed - res.data.refunded).toFixed(2);
            this.refund_show = res.data.payed - res.data.refunded;
            this.orderTime = timeToDate(res.data.ctime);
          } else {
            this.$msg(this.$t('orderNotAfter'), "error"); // 订单不可以进行售后
          }
          this.listData = res.data
        } else {
          this.$msg(this.$t('orderNotFind'), "error"); //没有找到此订单
        }
      });
    }
  },
  created() {},
  mounted() {
    let order_id = this.$route.params.order_id;
    this.order_id = order_id;
    this.getOrderInfo();
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/variable.scss";
.result {
  margin-bottom: 20px;
}
.order-id, .order-time {
  margin-bottom: 10px;
}
.order-box {
  display: flex;
  text-align: center;
  align-items: center;
  &.list-head {
    height: 40px;
    line-height: 40px;
    background: $theme-bg;
  }
  &.list-box {
    border-bottom: 1px solid $border;
    // border-top: none;
    // border-left: 0;

    .order-list {
      display: inline-flex;
      border-left: 1px solid $border;
      border-right: 1px solid $border;
      padding: 20px 0;
      display: flex;
      flex-direction: column;
      .product-item {
        // margin: 0 10px;
        padding: 0 10px;
        display: flex;
        flex-direction: row;
        align-items: center;
        border-bottom: 1px solid #eee;
        padding: 10px;
        &:last-child {
          border: none;
        }
        .product-img {
          display: inline-block;
          width: 130px;
          height: 130px;
          flex: 0 0 50px;
          object-fit: cover;
          // margin-bottom: 10px;
        }
        .shop-info {
          display: flex;
          flex-direction: column;
          flex: 1;
          padding: 0 20px;
          align-items: flex-start;
          text-align: left;
          font-size: 16px;
          .title {
            width: 700px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            margin-bottom: 10px;
          }
          .desc {

            .item {
              margin: 10px 0;
              height: 20px;
            }
            input {
              border: 1px solid #eee;
              width: 40px;
              height: 24px;
              text-align: center;
            }
          }
        }
        .apply-btn {
          width: 50px;
          height: 20px;
          line-height: 20px;
          border: 1px solid $border;
          cursor: pointer;
          color: $theme-color;
          font-size: 12px;
          flex: 0 0 50px;
          &.active {
            background: $theme-color;
            color: #fff;
          }
          &:hover {
            background: $theme-color;
            color: #fff;
          }
        }
      }
    }
  }
  .order-id {
    width: 200px;
  }
  .order-list {
    flex: 1;
  }
  .order-time {
    width: 200px;
  }
}
.a-box {
  display: flex;
  margin-bottom: 10px;
  padding: 8px 0;
  &.money {
    .a-main {
      display: flex;
      flex-direction: column;
      .desc {
        font-size: 12px;
        margin-top: 10px;
      }
    }
  }
  .a-label {
    display: inline-block;
    width: 160px;
    text-align: right;
    margin-right: 20px;
    &.top10 {
      margin-top: 10px;
    }
  }
  .a-main {
    display: inline-flex;
    .a-img {
      width: 75px;
      height: 75px;
      display: inline-block;
      object-fit: cover;
      margin-right: 20px;
    }
    .a-name {
      display: inline-block;
    }
    .a-price-input {
      display: block;
      width: 180px;
      height: 30px;
      text-indent: 10px;
      color: $theme-color;
      font-size: 16px;
      border: 1px solid $border;
    }
    .textarea {
      width: 480px;
      resize: none;
      border: 1px solid $border;
      padding: 10px;
      &:focus {
        outline: none;
        border-color: $theme-color;
      }
    }
  }
}
.submit {
  width: 200px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: $theme-color;
  color: #fff;
  margin-left: 178px;
  margin-top: 30px;
  cursor: pointer;
}
.radio {
  margin-right: 10px;
}
</style>